import styled from 'styled-components'
import { ReactNode, useRef, useState } from 'react'
import { Container } from '..'
import { useClickOutside } from 'utils';

const StyledDropDown = styled(Container)`
  .dropdown-body-container {
    position: absolute;
    top: calc(100% + 8px);
    transition: ease-in-out all .3s;
    &.expanded {
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
    }
    &.collapsed {
      visibility: hidden;
      opacity: 0;
      transform: translateY(-8px);
    }
  }
`

export function Dropdown({
  isExpanded,
  onClose,
  children,
  trigger,
}: any) {

  const dropdownRef = useRef(null);
  useClickOutside(dropdownRef, onClose)
  return (
    <StyledDropDown expand REF={dropdownRef} className={'dropdown'}>
      {trigger()}
      <Container className={`${isExpanded ? 'expanded' : 'collapsed'} dropdown-body`}>
        {children}
      </Container>
    </StyledDropDown>
  )
}

export default Dropdown
